import { Flex } from "#shared/view/components/Flex";
import { Text } from "#shared/view/components/Text";

export const ClusterCardQuantity = ({ quantity }: { quantity: number }) => {
  return (
    <Flex justify={"space-between"} align={"center"}>
      <Text>Quantité :</Text>
      <Text>{quantity}</Text>
    </Flex>
  );
};
